<div *ngIf="true" style="padding-left: 0px;" class="options-block">
    <div class="row">
        <div class="col-sm-12">
        <span style="padding-left: 0px;" class="col-sm-5">
            <h3>Réservations</h3>
        </span>
            <span class="col-sm-7 totals">
            <span class="total-count">
                {{getTotalOptions()}} en attente,
                {{getCountRegistration()}} confirmés
                <span *ngIf="getRemainingPlaces() !== ''" [ngClass]="{'text-danger': getRemainingPlaces() < 0}">
                    , <i *ngIf="getRemainingPlaces() < 0" class="fa fa-exclamation-triangle"
                         aria-hidden="true"></i> {{getRemainingPlaces()}} places restantes
                </span>
            </span>
        </span>
        </div>
    </div>

    <form role="form" #optionForm="ngForm" novalidate show-validation>
        <div *ngFor="let option of registrationOptions; let i = index">
            <div class="option-result col-sm-12 form-group" title="Editer"
                 (click)="clickOnOption(option, leaveOptionModal)">
                <!-- Company -->
                <div class="option-param col-sm-7 company">
                    <span class="option-title">Société: </span>

                    <span *ngIf="option.id === currentEditingOptionId">
                            <span *ngIf="companyInput.dirty && companyInput.invalid"
                                  class="error-message control-error">
                                <small class="form-text text-danger"
                                       *ngIf="companyInput.errors.required">
                                    Nom de société requis
                                </small>
                                <small class="form-text text-danger"
                                       *ngIf="companyInput.errors.minlength">
                                    Nom de société inférieur à la taille minimum
                                </small>
                                <small class="form-text text-danger"
                                       *ngIf="companyInput.errors.maxlength">
                                    Taille maximum du nom de société dépassée
                                </small>
                            </span>

                            <textarea class="input-option col-sm-12 form-control"
                                      type="text" id="company" name="company" minlength="1" maxlength="244"
                                      #companyInput="ngModel" [(ngModel)]="option.companyName" required></textarea>
                        </span>
                    <span *ngIf="option.id !== currentEditingOptionId" class="value">
                            {{option.companyName}}
                        </span>
                </div>

                <!-- Nb Students -->
                <div class="option-param col-sm-3">

                    <span class="option-title">Qté stagiaires: </span>

                    <span *ngIf="option.id === currentEditingOptionId">
                            <span *ngIf="nbStudents.dirty && nbStudents.invalid" class="error-message control-error">
                                <small class="form-text text-danger"
                                       *ngIf="nbStudents.errors.required">
                                        Quantité requise
                                </small>
                            </span>

                            <input class="input-option col-sm-12 form-control" type="number"
                                   [(ngModel)]="option.nbStudents" id="nbStudents"
                                   name="nbStudents" #nbStudents="ngModel" pattern="[0-9]*" required/>
                        </span>
                    <span *ngIf="option.id !== currentEditingOptionId">
                            {{option.nbStudents}}
                        </span>
                </div>

                <!-- OPCA Status -->
                <div class="option-param col-sm-2">
                    <span class="option-title">{{ 'session-details.student-tab.registration-options.opcaStatus' | translate}}:</span>
                    <div *ngIf="option.id === currentEditingOptionId" class="dropdown">
                        <button class="btn btn-default dropdown-toggle opca-button" type="button" id="dropdownMenu1"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                            {{opcaStatusMap[option.opcaStatus]}}
                            <span class="caret"></span>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                            <li *ngFor="let status of opcaStatusList">
                                <a type="button" (click)="updateSelectedOpcaStatus(option, status[1])">{{status[0]}}</a>
                            </li>
                        </ul>
                    </div>
                    <span *ngIf="option.id !== currentEditingOptionId">
                        {{opcaStatusMap[option.opcaStatus]}}
                    </span>
                </div>

                <!-- Infos Commercial-->
                <div class="option-param col-sm-7">
                    <span class="option-title">Informations<span *ngIf="option.id === currentEditingOptionId"> (facultatif)</span>: </span>
                    <textarea *ngIf="option.id === currentEditingOptionId"
                              class="input-option col-sm-12 form-control" type="text"
                              [(ngModel)]="option.commercialInfo" id="commercialInfo" name="commercialInfo"
                              #companyInput="ngModel">
                        </textarea>
                    <span *ngIf="option.id !== currentEditingOptionId">
                            {{option.commercialInfo}}
                        </span>
                </div>

                <!-- Commercial Name -->
                <div class="col-sm-5 option-param">
                    <span class="option-title">Commercial: </span>

                    <span *ngIf="option.id === currentEditingOptionId">
                            <span *ngIf="commercial.dirty && commercial.invalid" class="error-message">
                                <small class="form-text text-danger"
                                       *ngIf="commercial.errors.required">
                                        Commercial requis
                                </small>
                            </span>
                            <input id="commercial" class="form-control commercial" auto-complete #commercial="ngModel"
                                   [ngClass]="{'disable-change': !isCurrentUserAdmin}" [(ngModel)]="option.commercial"
                                   [source]="usersNames" [ngModelOptions]="{standalone: false}"
                                   [accept-user-input]="false" [min-chars]="1" [max-num-list]="7"
                                   name="commercial" required/>
                        </span>
                    <span *ngIf="option.id !== currentEditingOptionId">
                            {{option.commercial}}
                        </span>
                </div>

                <!-- Comments -->
                <div class="col-sm-10 option-param"
                     *ngIf="option.id === currentEditingOptionId || (option.comments && option.comments.length > 0)">
                    <span class="option-title">Commentaires<span *ngIf="option.id === currentEditingOptionId"> (facultatif)</span>: </span>
                    <textarea *ngIf="option.id === currentEditingOptionId"
                              class="input-option col-sm-12 form-control" type="text" [(ngModel)]="option.comments"
                              id="comments" name="comments"></textarea>
                    <div *ngIf="option.id !== currentEditingOptionId">
                        {{option.comments}}
                    </div>
                </div>

                <!-- Edit Buttons -->
                <div class="col-sm-2 edit-button">
                        <span role="group" *ngIf="option.id === currentEditingOptionId">
                            <button type="submit"
                                    class="form-group form-validation option-button btn btn-primary btn-sm"
                                    (click)="saveOptionChanges(option)"
                                    [disabled]="optionForm.form.invalid || isAbleToSave() === false"
                                    title="Enregistrer"
                                    type="button">
                                <i class="fa fa-fw fa-check"></i>
                            </button>
                            <button (click)="cancelEditOption()" title="Annuler"
                                    class="option-button btn btn-default btn-sm" type="button">
                                <i class="fa fa-fw fa-ban"></i>
                            </button>
                            <button (click)="showModalDeleteOption(deleteModal)"
                                    class="option-button btn btn-default btn-sm" type="button"
                                    title="Supprimer">
                                <i class="fa fa-fw fa-trash"></i>
                            </button>
                        </span>
                </div>
            </div>
        </div>
    </form>
    <span class="col-sm-12 add-option-section" role="button"
          [ngClass]="{'disabled' : currentEditingOptionId != -1}"
          (click)="addRegistrationOption()">
            <i class="fa fa-plus-circle"></i> Ajouter une reservation
    </span>
</div>


<ng-template #deleteModal>
    <div class="modal-header">
        <h4 class="modal-title">Êtes-vous sur de vouloir supprimer cette réservation?</h4>
    </div>
    <div class="modal-footer">
        <button style="margin-bottom: 0px" type="button" class="btn btn-default" (click)="closeDeleteModal()">Annuler
        </button>
        <button type="button" class="btn btn-primary" (click)="deleteCurrentEditingOption()">Supprimer</button>
    </div>
</ng-template>

<ng-template #leaveOptionModal>
    <div class="modal-header">
        <h4 class="modal-title">Êtes-vous sur de vouloir quitter l'édition de cette réservation? &nbsp;
            (Toute modification sera perdue)</h4>
    </div>
    <div class="modal-footer">
        <button style="margin-bottom: 0px" type="button" class="btn btn-default" (click)="editFuturOption()">Quitter
            l'édition
        </button>
        <button type="button" class="btn btn-primary" (click)="closeLeaveModal()">Revenir à l'édition</button>
    </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-booking/registration-booking.component.html